import { forwardRef } from 'react';
import { Button as MuiButton } from '@mui/joy';

let white = {
  color: 'neutral.900',
  backgroundColor: '#fff',
  boxShadow: 'var(--joy-shadow-sm)',
  '&:hover': { backgroundColor: 'neutral.50' },
  '--Icon-color': 'var(--joy-palette-neutral-700)',  
};

let black = {
  color: '#fff',
  backgroundColor: 'neutral.900',
  '&:hover': { backgroundColor: 'neutral.900' },
  '--Icon-color': '#fff',
};

let neutral = {
  color: 'neutral.700',
  backgroundColor: 'neutral.200',
  '&:hover': { backgroundColor: 'neutral.300' },
  '--Icon-color': 'var(--joy-palette-neutral-500)',
};

let xs = {
  borderRadius: '8px',
  fontSize: '10.5px',
  fontWeight: 600,  
  lineHeight: '10.5px',
  paddingBlock: '6px',
  paddingInline: '10px',
  minHeight: '26px',
  minWidth: '26px',
  '--Button-gap': '6px', 
  '--Icon-fontSize': '14px',
};

let xssm = {
  color: 'var(--joy-palette-neutral-900)',
  fontSize: '11.5px',
  fontWeight: 600,
  lineHeight: '11.5px',
  minHeight: '28px',
  minWidth: '28px',
  paddingBlock: '6px',
  paddingInline: '11px',
};

let sm = {
  fontSize: '11.5px',
  fontWeight: 600,
  lineHeight: '11.5px',
  minHeight: '30px',  
  paddingBlock: '7px',
  paddingInline: '13px',
  '--Icon-fontSize': '13px',
}

export const Button = forwardRef(function Button({ color="primary", type="normal", shape="default", size="md", disabled=false, children, ...props}, ref) {
  let sx = {
    borderRadius: shape === 'pill' ? '999px' : 'md',
    fontSize: 13.5,
    fontWeight: 700,
    lineHeight: '20px',    
    paddingBlock: '10px',
    paddingInline: shape === 'pill' ? '16px 20px' : (type === 'wider' ? '24px' : '20px'),
    ...(color === 'white' && white),
    ...(color === 'black' && black),
    ...(color === 'neutral' && neutral),
    ...(size === 'sm' && sm),
    ...(size === 'xssm' && xssm),
    ...(size === 'xs' && xs),
    ...props.sx,    
    ...(disabled && color === 'neutral' && {
      backgroundColor: 'var(--joy-palette-neutral-200)',
      color: 'var(--joy-palette-neutral-500)',      
      opacity: 0.75,      
      cursor: 'default',
      '&:hover': { backgroundColor: 'var(--joy-palette-neutral-200)' },
    }),
    ...(type === 'icon' && {
      padding: 0,            
      '--Icon-fontSize': '16px',
      '--Icon-color': 'var(--joy-palette-neutral-700)',
    }),
  };  
  return (
    <MuiButton {...props} ref={ref} color={color} size={size} sx={sx}>
      {children}
    </MuiButton>
  );
});